import ClaimCentresPage from 'containers/ClaimCentres';

export default ClaimCentresPage;
